import { GestureResponderEvent } from 'react-native'
import { ProductsMegaMenu } from '../ProductsMegaMenu'

interface ProductBoxInterface {
  visible: boolean
  productLayout?: GestureResponderEvent
  showProductModal: () => void
  hideProductModal: () => void
}

export const ProductBox = ({ visible, productLayout, showProductModal, hideProductModal }: ProductBoxInterface) => {
  return (
    <ProductsMegaMenu
      visible={visible}
      productLayout={productLayout}
      hideProductModal={hideProductModal}
      showProductModal={showProductModal}
    />
  )
}
